/**
 * Best-effort relay of Razorpay's success callback to
 * `POST /v1/purchases/:id/checkout/verify`, shared by the Buy Now and Cart
 * checkout hooks. Deliberately swallows every failure: a 400 (tampered
 * triple), 404 (not our order), or a network blip must not change what the
 * customer sees — the backend-verified poll is the only thing that decides
 * paid/failed (razorpay/payment-flow.md §2). On success the backend completes
 * a Razorpay-confirmed capture in-request (fast path, 2026-09-24), which is
 * what lets that poll resolve on its first tick instead of after the webhook.
 */
import { verifyCheckout } from './api';
import type { RazorpaySuccessResponse } from './razorpayCheckout';

export async function relayCheckoutResult(purchaseId: string, response: RazorpaySuccessResponse): Promise<void> {
  try {
    await verifyCheckout(purchaseId, response);
  } catch {
    // advisory only — see doc comment
  }
}
